import React from "react";
import PropTypes from "prop-types";
import { Tags } from "@tryghost/helpers-gatsby";

import * as style from "../styles/post-tag-date.module.scss";

const PostTagDate = ({ post }) =>
    post.tags && (
        <Tags
            post={post}
            visibility={`public`}
            slug
            autolink={true}
            permalink={`/insights/:slug`}
            linkClasses={`${style.clarsyntPostTagDate}`}
        />
    );

PostTagDate.propTypes = {
    post: PropTypes.shape({
        tags: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                slug: PropTypes.string,
            })
        ),
    }).isRequired,
};

export default PostTagDate;
